import { Link } from "react-router-dom";
import Logo from "../ui/Logo";
import {
  Facebook01Icon,
  TiktokIcon,
  CallIcon,
  Location01Icon,
  ArrowLeft02Icon,
  Message01Icon,
} from "hugeicons-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  // WhatsApp number - format: country code + number without leading zero
  const whatsappNumber = "218930303046"; // Libya: 218, then 930303046
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <footer className="bg-[#050000] text-white pt-20 pb-8 relative overflow-hidden border-t border-white/5 bg-carbon">
      {/* Cinematic Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050000] via-transparent to-[#050000] opacity-80 pointer-events-none" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent shadow-[0_0_20px_rgba(227,30,36,0.5)]" />
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[800px] h-48 bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-3 space-y-6">
            <Link to="/" className="group inline-block transition-transform duration-500 hover:scale-105">
              <Logo className="w-44 h-auto" />
            </Link>
            <p className="text-gray-400 leading-relaxed text-sm font-light">
              الوجهة الأولى للعناية الفاخرة بالسيارات. نجمع بين الشغف
              والاحترافية لتقديم نتائج تفوق التوقعات في عالم التفصيل.
            </p>
            <div className="flex gap-4">
              {[
                { icon: Facebook01Icon, url: "https://www.facebook.com/profile.php?id=61582575836144", label: "Facebook" },
                { icon: TiktokIcon, url: "https://www.tiktok.com/@four.m4444", label: "TikTok" },
                { icon: Message01Icon, url: whatsappUrl, label: "WhatsApp" }
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  className="w-12 h-12 rounded-2xl bg-white/[0.03] border border-white/10 flex items-center justify-center hover:bg-primary/20 hover:border-primary/50 transition-all duration-500 hover:-translate-y-2 group shadow-lg overflow-hidden relative"
                >
                   <div className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-10 transition-opacity" />
                  <social.icon size={22} className="relative z-10 text-gray-400 group-hover:text-primary transition-colors" />
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          <div className="lg:col-span-2 space-y-6">
            <h4 className="font-bold text-lg">الروابط السريعة</h4>
            <ul className="space-y-4">
              {[
                { name: "الرئيسية", href: "/" },
                { name: "أعمالنا", href: "/our-works" },
                { name: "من نحن", href: "/#about-us" },
                { name: "تواصل معنا", href: "/#location" },
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-400 hover:text-primary transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2 space-y-6">
            <h4 className="font-bold text-lg">خدماتنا</h4>
            <ul className="space-y-4">
              {[
                { name: "العناية الشاملة", href: "/services" },
                { name: "النانو سيراميك", href: "/services" },
                { name: "أفلام حماية PPF", href: "/services" },
                { name: "تلميع وبولش", href: "/services" },
                { name: "تنظيف داخلي عميق", href: "/services" },
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-gray-400 hover:text-primary transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2 space-y-6">
            <h4 className="font-bold text-lg">الدعم</h4>
            <ul className="space-y-4">
               <li>
                 <a
                   href={whatsappUrl}
                   target="_blank"
                   rel="noreferrer"
                   className="text-gray-400 hover:text-primary transition-colors text-sm"
                 >
                   مساعدة
                 </a>
               </li>
               <li>
                 <Link
                   to="/privacy"
                   className="text-gray-400 hover:text-primary transition-colors text-sm"
                 >
                   سياسة الخصوصية
                 </Link>
               </li>
               <li>
                 <Link
                   to="/terms"
                   className="text-gray-400 hover:text-primary transition-colors text-sm"
                 >
                   الشروط والأحكام
                 </Link>
               </li>
            </ul>
          </div>

          {/* Newsletter / Contact */}
          {/* Contact Information */}
          <div className="lg:col-span-3 space-y-6">
            <h4 className="font-black text-lg tracking-wider uppercase flex items-center gap-3">
               <span className="w-6 h-[1px] bg-primary" />
               تواصل معنا 
            </h4>
            <div className="grid grid-cols-1 gap-4">
              {[
                { icon: CallIcon, value: "0930303046", label: "رقم الهاتف", ltr: true },
                { icon: Message01Icon, value: "تواصل مباشر", label: "واتساب", url: whatsappUrl },
                { icon: Location01Icon, value: "السياحية، طرابلس", label: "الموقع" }
              ].map((contact, idx) => (
                <div 
                  key={idx}
                  className="group flex items-center gap-4 p-3 rounded-xl bg-white/[0.02] border border-white/5 hover:border-primary/30 transition-all duration-500 hover:bg-white/[0.04] cursor-pointer"
                  onClick={() => contact.url && window.open(contact.url, "_blank")}
                >
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
                    <contact.icon size={18} />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[9px] text-gray-400 font-bold uppercase tracking-widest">{contact.label}</span>
                    <span className={`text-white text-base font-black tracking-tight ${contact.ltr ? 'font-mono' : ''}`} dir={contact.ltr ? 'ltr' : 'rtl'}>
                      {contact.value}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary text-xs font-black">
              M4
            </div>
            <p className="text-gray-500 text-sm font-medium">
              © {currentYear} M FOUR Premium. جميع الحقوق محفوظة.
            </p>
          </div>
          <div className="flex items-center gap-8">
            <button 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-[10px] text-gray-400 hover:text-primary font-black uppercase tracking-[0.3em] transition-colors flex items-center gap-2 group"
            >
              العودة للأعلى 
              <ArrowLeft02Icon size={14} className="rotate-90 group-hover:-translate-y-1 transition-transform" />
            </button>
            <div className="h-4 w-px bg-white/5 hidden md:block" />
            <a 
              href="https://www.facebook.com/mosab.nabil.520/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 group"
            >
              <span className="text-gray-600 text-[10px] font-black uppercase tracking-widest italic group-hover:text-primary transition-colors">تم التصميم بواسطة</span>
              <div className="flex items-center justify-center p-2 rounded-xl bg-white/[0.03] border border-white/5 group-hover:border-primary/40 transition-all shadow-lg">
                <Facebook01Icon size={14} className="text-gray-500 group-hover:text-primary transition-colors" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
